{
    "LinkInput_Title": "Titolo",
    "LinkInput_URL": "URL",
    "LinkInput_Target": "Bersaglio",
    "LinkInput_NewTab": "Apri in una nuova scheda",
    "LinkInput_CurrentTab": "Apri nella scheda corrente",
    "NAME": "LinkInputLanguage"
}